/* eslint-env es6 */
const mutations = {
  setKeyWord (state, val) {
    state.keyWord = val
  },
  setLiveShopObj (state, val) {
    state.liveShopOBj = val
  },
  setChannelBrand (state, val) {
    state.channelBrand = val
  }
}
export default mutations
